<div mat-dialog-title>
  <div class="flex items-center justify-between h-48">
    <h6>Add Invoice</h6>
    <button matIconButton aria-label="Close" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-divider class="mx-20!" />
<div mat-dialog-content>
  <div class="title-1 text-neut-50">Send the invoice directly to {{ data?.insurerName }}</div>
  <div class="flex items-center my-20! ml-15! gap-x-10 subtitle-2">
    <mat-icon>info_outlined</mat-icon>
    <span class="text-neut-50">
      The insurer is not using EstImage for this job and the invoice must be sent by other means. You can remove the job
      from your Dashboard
    </span>
  </div>
</div>
<mat-divider class="mx-20!" />
<mat-dialog-actions>
  <button matButton="elevated" class="charcoal-button" mat-dialog-close>CANCEL</button>
  <button matButton="elevated" class="red-button" [disabled]="pending()" (click)="hideJob()">REMOVE JOB</button>
</mat-dialog-actions>
